<template>
    <div class="swiper-latest-news-wrapper">
        <div class="swiper-latest-news">
            <div class="swiper-wrapper">
                <div
                    v-for="(slide, index) in latestNews"
                    :key="'swiper-partners-slide-' + index"
                    class="swiper-slide"
                >
                    <NewsCard :newsData="slide" :showColumn="false" />
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

// import Swiper bundle with all modules installed
import Swiper from 'swiper/swiper-bundle.js'

import NewsCard from '@/components/loopTemplate/NewsCard'

// import styles bundle
import 'swiper/swiper-bundle.min.css'

export default {
    name: 'SwiperLatestNews',
    components: {
        NewsCard,
    },
    props: {
        latestNews: {
            type: Array,
            required: true,
        },
    },
    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    setTimeout(function () {
                        new Swiper('.swiper-latest-news', {
                            // Optional parameters
                            loop: false,
                            grabCursor: true,
                            slidesPerView: 'auto',
                            centeredSlides: false,
                            spaceBetween: 10,
                            // If we need pagination
                            pagination: {
                                el: '.swiper-pagination',
                                clickable: true,
                            },
                        })
                    }, 2000)
                }
            },
            immediate: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['content']),
    },
}
</script>
